import {createArrayInstance, ModelProperties} from '../utils';
import {CtLocaleKey} from './ct-locale-key';

export class CtLocaleCategory {
    id!: number;

    name!: string;

    global!: boolean;

    keys?: CtLocaleKey[];

    constructor(category?: ModelProperties<CtLocaleCategory>) {
        if (category) {
            Object.assign(this, category);
            this.keys = createArrayInstance(CtLocaleKey, category.keys);
        }
    }
}